import {PaymentMethodResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/PaymentMethodResponse';

export class PaymentMethod
{
    constructor(public readonly hasPaymentMethod:any,
                // public readonly publicKey:string,
                public readonly cardType:any,
                public readonly cardLast4:string,
                // public readonly expirationMonth:number,
                // public readonly expirationYear:number,
                // public readonly currentInvoiceDueDate:number
    )
    {}

    public displayCardType():string
    {
        const cardType = this.cardType;
        const cardTypeStr = cardType.charAt(0).toUpperCase() + cardType.substring(1).toLowerCase();

        return `${cardTypeStr} ending in`;
    }

    public displayInvoiceDueDate():string
    {
        // const invoiceDue = new Date(this.currentInvoiceDueDate);
        // const day = invoiceDue.getDay();
        // // const month = invoiceDue.getMonth();
        // const year = invoiceDue.getFullYear();
        //
        // const locale = "en-us";
        // const month = invoiceDue.toLocaleString(locale, {month: "long"});

        // return `${month} ${day}, ${year}`;
        return 'TODO !!!';
    }


    public static fromResponse(resp:PaymentMethodResponse)
    {
        return new PaymentMethod(   resp.hasPaymentMethod,
                                    // resp.publicKey,
                                    resp.cardType,
                                    resp.cardLast4,
                                    // resp.expirationMonth,
                                    // resp.expirationYear,
                                    // resp.currentInvoiceDueDate
                                 );
    }
}
